<div class="row margin-class">
    <h4><span class="badge badge-primary"><i class="fa fa-film" aria-hidden="true"></i>&nbsp; Indian Movie Tracker By Sarathlal</span></h4>
</div>
<div class="row margin-class">
    <div class="row col-5">
        <div class="col-6">
            <h5><span class="badge badge-secondary">Choose an Industry</span></h5>
            <select name="selectedIndustry" id="industry" class="form-control" [(ngModel)]="selectedIndustry"
                (change)='onIndustrySelected()'>
                <option>All Industries</option>
                <option *ngFor="let data of industries" [value]="data.Code">{{data.Name}}</option>
            </select>
        </div>
        <div class="col-6" *ngIf="selectedIndustry != undefined">
            <h5><span class="badge badge-secondary">Select an Actor</span></h5>
            <select style="background-color:khaki" name="selectedActor" id="actor" class="form-control" [(ngModel)]="selectedActor"
                (change)='onActorSelected()'>
                <option *ngFor="let data of selectedActors" [value]="data.Code">{{data.Name}}</option>
            </select>
        </div>
        <div class="col-6" *ngIf="selectedActor != undefined">
            <h5><span class="badge badge-secondary">Choose a Language</span></h5>
            <select name="selectedLanguage" id="language" class="form-control" [(ngModel)]="selectedLanguage"
                (change)='onLanguageSelected()'>
                <option [value]="All">All ({{selectedMovies.length}})</option>
                <option *ngFor="let data of groupedLanguages | keyvalue" [value]="data.key">{{data.key}} ({{data.value}})</option>
            </select>
        </div>
        <div class="col-6" *ngIf="selectedActor != undefined">
            <h5><span class="badge badge-secondary">Choose a Director</span></h5>
            <select name="selectedDirector" id="director" class="form-control" [(ngModel)]="selectedDirector"
                (change)='onDirectorSelected()'>
                <option [value]="All">All ({{selectedMovies.length}})</option>
                <option *ngFor="let data of groupedDirectors | keyvalue" [value]="data.key">{{data.key}} ({{data.value}})</option>
            </select>
        </div>
        <div class="col-6" *ngIf="selectedActor != undefined">
            <h5><span class="badge badge-secondary">Choose an Year</span></h5>
            <select name="selectedYear" id="year" class="form-control" [(ngModel)]="selectedYear"
                (change)='onYearSelected()'>
                <option [value]="All">All ({{selectedMovies.length}})</option>
                <option *ngFor="let data of groupedYears | keyvalue" [value]="data.key">{{data.key}} ({{data.value}})</option>
            </select>
        </div>
    </div>
    <div class="row margin-class" *ngIf="selectedActor != undefined">
        <img width="350px" src="../assets/{{selectedActor}}.jpg" />
    </div>
    <div class="col-8" *ngIf="selectedMovies != undefined">
        <table class="table table-hover">
            <thead>
                <tr class="d-flex table-warning">
                    <th class="col-2">Year</th>
                    <th class="col-3">Title</th>
                    <th class="col-2">Role</th>
                    <th class="col-3">Director</th>
                    <th class="col-2">Language</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of filteredMovies" class="d-flex table-primary">
                    <td class="col-2"> {{data.Year}}</td>
                    <td class="col-3"> {{data.Title}} </td>
                    <td class="col-2"> {{data.Role}}</td>
                    <td class="col-3"> {{data.Director}} </td>
                    <td class="col-2"> {{data.Language}} </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- <div class="col-3" *ngIf="selectedMovies != undefined">
        <table class="table table-hover">
            <thead>
                <tr class="d-flex table-info">
                    <th class="col-8">Actor</th>
                    <th class="col-4">Total Movies</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of groupedActors | keyvalue" class="d-flex table-primary">
                    <td class="col-8"> {{data?.key}}</td>
                    <td class="col-4"> {{data?.value}} </td>
                </tr>
            </tbody>
        </table>
    </div> -->
</div>
